// Needs a refactor, as this is not reproducable at all
var fadeshows = document.getElementsByClassName("fadeshow");
var currentSlide = 0;

for (var fsIndex = 0; fsIndex < fadeshows.length; fsIndex++) {
    var slidesContainer = fadeshows[fsIndex].getElementsByClassName("fadeshow__slides")[0];
    var slides = slidesContainer.getElementsByClassName("fadeshow__slide");

    slidesContainer.setAttribute("style", "width: " + (100 * slides.length) + "%");

    for (var slideIndex = 0; slideIndex < slides.length; slideIndex++) {
        slides[slideIndex].setAttribute("style", "left: " + (((100 / slides.length) * slideIndex) * -1) + "%");
    }

    // Click event listener on arrows
    var arrows = fadeshows[fsIndex].getElementsByClassName("fadeshow__arrow");

    for (var arrowIndex = 0; arrowIndex < arrows.length; arrowIndex++) {
        arrows[arrowIndex].addEventListener("click", function(event) {
            var arrowDir = event.target.getAttribute("data-fs-arrow-dir");

            if (arrowDir == "right") {
                nextSlide();
            } else {
                previousSlide();
            }
        });
    }

    // Click event listener on bullets
    var bullets = fadeshows[fsIndex].getElementsByClassName("fadeshow__bullet");

    for (var bulletIndex = 0; bulletIndex < bullets.length; bulletIndex++) {
        bullets[bulletIndex].addEventListener("click", function(event) {
            var bullet = event.target.getAttribute('data-fs-bullet');

            currentSlide = parseInt(bullet);

            setNewCurrentSlide(slides, currentSlide);
        });
    }


}

let interval = '';

document.addEventListener("DOMContentLoaded", function() {


    for (var i = 0; i < fadeshows.length; i++) {
        //Start the slide onload
        setNewSlideInterval();
        fadeshows[i].removeAttribute("style");
    }
});

function nextSlide() {
    if (currentSlide === slides.length - 1) {
        currentSlide = 0;
    } else {
        currentSlide++;
    }

    setNewCurrentSlide(slides, currentSlide);
}

function previousSlide() {
    if (currentSlide === 0) {
        currentSlide = slides.length - 1;
    } else {
        currentSlide--;
    }

    setNewCurrentSlide(slides, currentSlide);
}

function setNewCurrentSlide(slides, newCurrentSlide) {

    setNewSlideInterval();

    for (var slideIndex = 0; slideIndex < slides.length; slideIndex++) {
        slides[slideIndex].classList.remove("fadeshow__slide--shown");
        bullets[slideIndex].classList.remove("fadeshow__bullet--current");
    }

    document.querySelector(".fadeshow__slide[data-fs-slide='" + newCurrentSlide + "']").classList.add("fadeshow__slide--shown");
    document.querySelector(".fadeshow__bullet[data-fs-bullet='" + newCurrentSlide + "']").classList.add("fadeshow__bullet--current");

}

function setNewSlideInterval(){
    window.clearInterval(interval);
    interval = window.setInterval(nextSlide, 4000);
}


